import { SnackbarService } from 'app/shared/service/snackbar.service';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UserbackService } from '../service/userback.service';
import { helpWidgetConfig } from '../misc/help-widget.constant';
import { AuthService } from 'app/core/auth/auth.service';
import { BreadcrumbService } from '../service/breadcrumb.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-help-widget',
  templateUrl: './help-widget.component.html',
  styleUrl: './help-widget.component.scss',
  standalone: true,
  imports: [TranslateModule],
})
export class HelpWidgetComponent implements OnInit {
  private readonly docsExpandedStorageKey = 'helpWidgetExpanded';
  private readonly autoExpandMinViewportWidth = 1600;

  isPanelOpen = false;
  showDocsModal = false;
  isDocsCollapsed = false;
  isDocsExpanded = false;
  docsBaseUrl = helpWidgetConfig.docs.baseUrl;
  contextKey = '';
  docsUrl!: SafeResourceUrl;

  get safeContextKey(): string {
    return this.contextKey || helpWidgetConfig.docs.defaultContext;
  }

  get docsUrlString(): string {
    return this.buildDocsUrl();
  }

  get isAuthenticated(): boolean {
    return this.authStateService.isAuthenticated();
  }

  enableUserback: boolean = false;
  isHelpCenterWidgetEnabled: boolean = false;

  constructor(
    private sanitizer: DomSanitizer,
    private userbackService: UserbackService,
    private authStateService: AuthService,
    private breadcrumbService: BreadcrumbService,
    private translateService: TranslateService,
    private _snackBar: MatSnackBar,
    private router: Router,
     private snackbarService: SnackbarService
  ) { }

  ngOnInit(): void {
    const storedExpanded = localStorage.getItem(this.docsExpandedStorageKey);
    this.isDocsExpanded = storedExpanded !== null
      ? storedExpanded === 'true'
      : window.innerWidth > this.autoExpandMinViewportWidth;

    this.userbackService.helpCenterWidgetEnable$.subscribe(enabled => {
      this.isHelpCenterWidgetEnabled = enabled;
      if (this.isHelpCenterWidgetEnabled) {
        this.userbackService.initUserback();
      }
    });
    this.isHelpCenterWidgetEnabled = JSON.parse(localStorage.getItem('helpCenterWidget'));
    if (this.isHelpCenterWidgetEnabled && !this.userbackService.isUserbackReady() && localStorage.getItem('variantType') !== 'User') {
      this.userbackService.initUserback();
    }
    this.breadcrumbService.breadcrumbs$.subscribe(breadcrumb => {
      this.contextKey = breadcrumb[breadcrumb.length - 1]?.key || '';
      this.enableUserback = localStorage.getItem('variantType') !== 'User';
      if (this.router.url.includes('/sign-out')) {
        this.isPanelOpen = false;
        this.showDocsModal = false;
        if (this.userbackService.isUserbackReady()) {
          this.userbackService.hideLauncher();
          this.userbackService.closeFeedback();
        }
        this.userbackService.setHelpCenterWidgetEnable(false);
      }
      
      // Update docs URL when breadcrumb changes if panel is open
      if (this.showDocsModal) {
        this.docsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          this.buildDocsUrl()
        );
      }
    });
  }

  openFeedback(type: 'general' | 'bug' | 'feature_request'): void {
    if (!this.userbackService.isUserbackReady()) {
      this.snackbarService.showSnackbar({
        message: this.translateService.instant('errorSomethingWentWrong'),
        duration: 3000,
      });
      this.isPanelOpen = false;
      return;
    }
    this.userbackService.openFeedback(type);
    this.isPanelOpen = false;
  }

  buildDocsUrl(): string {
    const params: string[] = [];
    const token = this.userbackService.getDocsToken();
    if (token) params.push(`t=${token}`);
    params.push(`variant=${localStorage.getItem('variantType')}`);
    if (this.safeContextKey) {
      params.push(`contextKey=${this.safeContextKey}`);
    }

    return `${this.docsBaseUrl}?${params.join('&')}`;
  }

  openDocumentation(): void {
    if (!this.userbackService.getDocsToken()) {
      this.snackbarService.showSnackbar({
        message: this.translateService.instant('errorSomethingWentWrong'),
        duration: 3000,
      });
      this.isPanelOpen = false;
      return;
    }
    this.showDocsModal = !this.showDocsModal;
    this.isPanelOpen = false;
    this.docsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.buildDocsUrl()
    );
  }

  closeDocsModal(): void {
    this.showDocsModal = false;
    this.isDocsCollapsed = false;
  }

  toggleDocsCollapse(): void {
    this.isDocsCollapsed = !this.isDocsCollapsed;
  }

  toggleDocsExpand(): void {
    this.isDocsExpanded = !this.isDocsExpanded;
    localStorage.setItem(this.docsExpandedStorageKey, String(this.isDocsExpanded));
  }

  togglePanel(): void {
    if (!this.userbackService.isUserbackReady() && localStorage.getItem('variantType') !== 'User') {
      this.userbackService.initUserback();
    }
    this.isPanelOpen = !this.isPanelOpen;
    if (this.showDocsModal) {
      this.closeDocsModal();
    }
    this.userbackService.hideLauncher();
  }
}
